import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets scroll position to the top whenever the route changes.
 * Without this, React Router keeps the previous scroll position,
 * causing new pages to open mid-page (e.g. /gizlilik opening
 * scrolled down).
 *
 * Renders nothing. Mount it once inside <BrowserRouter>.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
